import React from 'react';
import classNames from 'classnames';
import { MOCK_UP_BACKGROUND_LAYER } from '../../../../propTypes';
import {
    DEFAULT_MIX_BLEND_MODE,
    DEFAULT_OPACITY,
    DEFAULT_Z_INDEX,
    DEFAULT_MAIN_COLOR,
    DEFAULT_CLASS_NAME,
} from '../../constants';
import './index.scss';

export const MockUpLayer = ({
    background = DEFAULT_MAIN_COLOR,
    zIndex = DEFAULT_Z_INDEX,
    mixBlendMode = DEFAULT_MIX_BLEND_MODE,
    opacity = DEFAULT_OPACITY,
    className = DEFAULT_CLASS_NAME,
    transformOrigin,
    transform,
}) => (
    <div
        style={{ zIndex, mixBlendMode, opacity, background, transformOrigin, transform }}
        className={classNames('layer', className)}
    />
);

MockUpLayer.propTypes = MOCK_UP_BACKGROUND_LAYER;
